import { create } from 'zustand';

interface SelectionModeStore {
  isActive: boolean;
  setIsActive: (value: boolean) => void;
}

export const useSelectionModeStore = create<SelectionModeStore>(set => ({
  isActive: false,
  setIsActive: value => set({ isActive: value }),
}));
